export const linkList = [
  { text: 'Последние новости', url: '/news' },
  { text: 'Актуальные акции', url: '/offers' },
  { text: 'Обзоры от экспертов', url: '/reviews' },
];
